import reduce from 'lodash/reduce';
export const emptyField = {
    focus: false,
    dirty: false,
    alreadyBlur: false,
    errors: [],
    asyncErrors: [],
    asyncValidating: 0,
};
export function mapFields(state, f) {
    const fields = f(state.fields);
    if (fields == state.fields) {
        return state;
    }
    return { ...state, fields: fields };
}
export function mapField(state, f, key) {
    return mapFields(state, (fields) => {
        const field = fields[key] ?? emptyField;
        const newField = f(field);
        if (field == newField) {
            return fields;
        }
        return { ...fields, [key]: newField };
    });
}
export function getField(state, key) {
    return state.fields[key] ?? emptyField;
}
export function hasFocus(state, key) {
    return getField(state, key).focus;
}
export function isBlur(state, key) {
    return !getField(state, key).focus;
}
export function isAlreadyBlur(state, key) {
    return getField(state, key).alreadyBlur;
}
export function isDirty(state, key) {
    return getField(state, key).dirty;
}
export function isAsyncValidating(state, key) {
    return Math.ceil(getField(state, key).asyncValidating) > 0;
}
export function formIsAsyncValidating(state) {
    return reduce(state.fields, (acc, field) => {
        return acc || Math.ceil(field.asyncValidating) > 0;
    }, false);
}
export function hasAsyncErrors(state, key) {
    return getField(state, key).asyncErrors.length > 0;
}
export function getAsyncErrors(state, key) {
    return getField(state, key).asyncErrors;
}
export function hasErrors(state, key) {
    return getField(state, key).errors.length > 0;
}
export function getErrors(state, key) {
    return getField(state, key).errors;
}
export function hasAnyErrors(state, key) {
    return hasAsyncErrors(state, key) || hasErrors(state, key);
}
export function formIsDirty(state) {
    return reduce(state.fields, (acc, field) => {
        return acc || field.dirty;
    }, false);
}
export function formIsAlreadyBlur(state) {
    return reduce(state.fields, (acc, field) => {
        return acc || field.alreadyBlur;
    }, false);
}
export function formHasFieldErrors(state) {
    return reduce(state.fields, (acc, field) => {
        return acc || field.errors.length > 0 || field.asyncErrors.length > 0;
    }, false);
}
export function formHasRootErrors(state) {
    return state.rootErrors.length > 0;
}
export function formHasSubmitErrors(state) {
    return state.submitErrors.length > 0;
}
export function formHasErrors(state) {
    return formHasRootErrors(state) || formHasSubmitErrors(state) || formHasFieldErrors(state);
}
export function submitSuccess(state) {
    return state.submitSuccess === true ? state : { ...state, submitSuccess: true };
}
export function isSubmitSuccess(state) {
    return state.submitSuccess;
}
export function isSubmitting(state) {
    return state.submitting;
}
export function getNbSubmits(state) {
    return state.nbSubmits;
}
